import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';

import './custom.css'

export default class App extends Component {
  static displayName = App.name;

    constructor(props) {
        super(props)
        this.state = { isInternal: false };
    }

    componentDidMount() {
        fetch('/api/authentication', {
            method: 'GET'
        })
            .then(resp => {
                if (resp.ok) {
                    resp.json().then(data => {
                        sessionStorage.setItem('isInternal', data);
                        this.setState({ isInternal: data });
                    })
                } else {
                    sessionStorage.setItem('isInternal', false);
                }
            })
    }

  render () {
    return (
      <Layout>
        <Route exact path='/' component={Home} />
      </Layout>
    );
  }
}
